import React from 'react';
import ProseMirror from 'legacy/src/components/content/ProseMirror/prose';

const RichTextEditor = ({ valueLink, hasError }) => (
  <div>
    <ProseMirror valueLink={valueLink} options={{ hasError }} />
  </div>
);

export default RichTextEditor;
